import makeStyles from "@mui/styles/makeStyles";
import { baseUrl } from "../../../shared/config";
import { Button, Paper, Container } from "@mui/material";
import SignUpWizard from "../components/SignUpWizard";
import { Login } from "@mui/icons-material";

const BACKGROUND_IMAGE_URL = `url(${baseUrl}/img/login-bg.jpg)`;

const useStyles = makeStyles((theme) => ({
  Main: {
    height: "100dvh",
    width: "100dvw",
    overflow: "auto",
    backgroundImage: BACKGROUND_IMAGE_URL,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: `${theme.spacing(4)} ${theme.spacing(3)}`,
    [theme.breakpoints.down("md")]: {
      padding: `${theme.spacing(2)} ${theme.spacing(0.25)}`,
    },
  },
  Paper: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",

    paddingTop: theme.spacing(3),
  },
  Header: {
    display: "flex",
  },
  Logo: {
    height: "100px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: theme.spacing(2),
  },
}));

export default function SignUpPage() {
  const classNames = useStyles();
  return (
    <main className={classNames.Main}>
      <Container>
        <header className={classNames.Header}>
          <img
            className={classNames.Logo}
            src={`${baseUrl}/img/LOGO_CLIENTE.PNG`}
            alt="company logo"
          />
          <Button
            startIcon={<Login />}
            sx={{ color: "white" }}
            href="/aluno/login"
          >
            Entrar
          </Button>
        </header>
        <Paper className={classNames.Paper}>
          <SignUpWizard />
        </Paper>
      </Container>
    </main>
  );
}
